import { type Static, Type } from '@sinclair/typebox';
import { AttributeSchema } from './attribute';

export const TaxonDTOSchema = Type.Recursive(T =>
  Type.Object({
    _key: Type.String(),
    children: Type.Array(T),
    count: Type.Number(),
    _id: Type.String(),
    name: Type.String(),
    total_delivery_spend_target_currency: Type.Number(),
    total_volume_metric_system: Type.Number(),
    total_volume_packs: Type.Number(),
  }),
);
export type TaxonDTO = Static<typeof TaxonDTOSchema>;

export const MonthsSchema = Type.Array(Type.Number());
export type Months = Static<typeof MonthsSchema>;

// =====================================================================================================================
// List Taxons
// =====================================================================================================================

export const ListTaxonsBodySchema = Type.Object({
  suppliers: Type.Optional(Type.Array(Type.String())),
  fromDate: Type.Optional(Type.Number()),
  toDate: Type.Optional(Type.Number()),
});
export type ListTaxonsBody = Static<typeof ListTaxonsBodySchema>;

export const ListTaxonsResponseSchema = TaxonDTOSchema;
export type ListTaxonsResponse = Static<typeof ListTaxonsResponseSchema>;

// =====================================================================================================================
// List Taxon Attributes
// =====================================================================================================================

export const ListTaxonAttributesBodySchema = Type.Object({
  taxonId: Type.Optional(Type.String()),
  suppliers: Type.Optional(Type.Array(Type.String())),
  xpath: Type.Optional(Type.String()),
});
export type ListTaxonAttributesBody = Static<typeof ListTaxonAttributesBodySchema>;

export const ListTaxonAttributesResponseSchema = Type.Object({
  filters: Type.Array(AttributeSchema),
  allergyCompliances: Type.Array(Type.String()),
  accreditations: Type.Array(Type.String()),
});
export type ListTaxonAttributesResponse = Static<typeof ListTaxonAttributesResponseSchema>;

// =====================================================================================================================
// List suppliers
// =====================================================================================================================

export const ListSuppliersBodySchema = Type.Object({
  taxonomy: Type.Optional(Type.String()),
});
export type ListSuppliersBody = Static<typeof ListSuppliersBodySchema>;

export const ListSuppliersResponseSchema = Type.Array(Type.String());
export type ListSuppliersResponse = Static<typeof ListSuppliersResponseSchema>;
